export interface SecurityPolicyGetDTO {
  securityPolicyId?: string;
  organisationId?: string;
  organisationVersionId?: number;
  communityTemplateId?: string;
  isDefault: boolean;
  userCreatorId: string;
  dateCreated?: Date | string;
  userLastModifierId?: string;
  dateLastModified?: Date | string;
  name: string;
  description: string;
  enableIncorrectPasswordLock: boolean;
  lockMinutes?: number;
  incorrectAttemptsNo?: number;
  incorrectAttemptsSeconds?: number;
  correctSecurityAnswerNo: number;
  minSecurityAnswerCharacters: number;
  minSecurityAnswersConfigured: number;
  passwordExpiryNoDays: number;
  inactivityTimeoutMinutes: number;
  twoFaRequiredOnLogin: boolean;
  passwordMinCharacterNo: number;
  passwordMaxCharacterNo: number;
  passwordLowerCaseRestriction: boolean;
  passwordLowerCaseNo?: number;
  passwordUpperCaseRestriction: boolean;
  passwordUpperCaseNo?: number;
  passwordNumberRestriction: boolean;
  passwordNumberNo?: number;
  passwordSpecialCharRestriction: boolean;
  passwordSpecialCharNo?: number;
  sequentialIdenticalCharsRestriction: boolean;
  usernameRestriction: boolean;
  usernameCharacterNo: number;
  passwordSpaceRestriction: boolean;
  passwordUsersNameRestriction: boolean;
  minUsersNameCharacters?: number;
  customRules?: Array<CustomRules>;
}

export interface SecurityPoliciesOfUserForReset {
  firstname: string;
  middlename: string;
  lastname: string;
  username: string;
  displayname: string;
  security: SecurityPolicyGetDTO;
}

interface CustomRules {
  ruleId?: string;
  ruleName: string;
  regularExpression: string;
  isEdited?: boolean; //front property to check which one is being edited
}
